import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { PropertiesSale } from 'src/common-services'
import { Flex, FlexColumn } from 'src/components/flex-containers'
import { PropertyRecordAccordion } from 'src/components/insights/property-records/property-record-accordion'
import { Grid, Typography } from '@mui/material'
import { formatVal } from 'src/utils/number-format'
import { GridPairKey, GridPairValue } from 'src/components/grid-pair'
import { formatString } from 'src/utils/format-string'

const Wrapper = styled(FlexColumn)`
  gap: ${Shapes.spacing[4]}px;
  padding-inline: ${Shapes.spacing[4]}px;
`

const TitleWrapper = styled(Flex)`
  width: 100%;
`
const TitleColumn = styled(FlexColumn)`
  flex: 1;
  gap: ${Shapes.spacing[2]}px;
`

const SectionContent = styled(Flex)``
const SectionColumn = styled(FlexColumn)`
  .MuiGrid-item {
    padding-bottom: ${Shapes.spacing[4]}px;
  }
`
const SectionFiller = styled.div`
  width: 14px;
`

const Sale = (props: { sale: PropertiesSale }) => {
  const { sale } = props

  const header = (
    <TitleWrapper>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Record Date
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {sale.recordedDate || '-'}
        </Typography>
      </TitleColumn>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Buyer
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {formatString(sale.buyer, 'name')}
        </Typography>
      </TitleColumn>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Seller
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {formatString(sale.seller, 'name')}
        </Typography>
      </TitleColumn>
      <TitleColumn gap={Shapes.spacing[2]}>
        <Typography variant="textmdm" color={Colors.textMedium}>
          Sale Amount
        </Typography>
        <Typography variant="textmd" color={Colors.textBlack}>
          {sale.salePrice !== 0 ? formatVal(sale.salePrice, 'currency-expanded') : 'N/A'}
        </Typography>
      </TitleColumn>
    </TitleWrapper>
  )
  return (
    <PropertyRecordAccordion
      title={header}
      content={
        <SectionContent>
          <SectionColumn
            style={{
              flex: 1,
            }}>
            <Grid container>
              <GridPairKey>Amount Type</GridPairKey>
              <GridPairValue>{sale.documentType || '-'}</GridPairValue>
              <GridPairKey>Transaction Type</GridPairKey>
              <GridPairValue>{sale.transactionType || '-'}</GridPairValue>
              <GridPairKey>Document Type</GridPairKey>
              <GridPairValue>{sale.documentType || '-'}</GridPairValue>
            </Grid>
          </SectionColumn>
          <SectionColumn
            style={{
              flex: 1,
            }}>
            <Grid container>
              <GridPairKey>Document #</GridPairKey>
              <GridPairValue>{sale.documentNumber || '-'}</GridPairValue>
              <GridPairKey>Foreclosed</GridPairKey>
              <GridPairValue>{sale.foreclosed ? 'Yes' : 'No'}</GridPairValue>
            </Grid>
          </SectionColumn>
          <SectionFiller />
        </SectionContent>
      }
    />
  )
}

export const PropertyRecordsDetailsSales = (props: { sales: PropertiesSale[] }) => {
  const { sales } = props

  return (
    <Wrapper>
      {sales.map((sale, index) => {
        return <Sale key={index + 'sale'} sale={sale} />
      })}
    </Wrapper>
  )
}
